export default [
    { key: 'code', label: 'ID', sortable: false },
    { key: 'name', label: 'Título' },
    { key: 'description', label: 'Descripción' },
    { key: 'created_at', label: 'Fecha Creación' },
    { key: 'due_date', label: 'Fecha Vencimiento' },
    { key: 'assignee.name', label: 'Responsable' },
    { key: 'resolution_date', label: 'Fecha Solución' },
    { key: 'approval_date', label: 'Fecha aprobación' },
    { key: 'notes', label: 'Notas', sortable: false },
    { key: 'files', label: 'Archivos', sortable: false },
    { key: 'actions', label: 'Acciones' },
]